module.exports = __webpack_public_path__ + "img/2.886f78fb.png";